//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"IsCylindrical",1,0],[0,"IsExternalConcave",1,0],[0,"IsExternalConvex",1,0],[0,"IsInternalConcave",1,0],[0,"IsInternalConvex",1,0],[0,"MinimumRadius",1,0],[1,"SelectBody",0,"SelectBodyList",0]],[[[],"CheckRadius",{},0,0],[[],"CorrectRadius",{},0,0],[["objectTag","boundaryType","checkType"],"CreateMinimumRadius",{},3,0]],[]];
SPLM.Tooling.CheckAndCorrectRadiusBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CheckAndCorrectRadiusBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;